import { deleteApiRequest } from 'api';

export const deleteNewsElements = (elementsIds: number[]): Promise<number[]> => {
    return deleteApiRequest('/news-element/bulk-delete/', {
        data: { ids: elementsIds },
    }).then(() => elementsIds);
};
